import { gql, useQuery, useMutation } from '@apollo/client';

const STAFF_NOTIFICATIONS_QUERY = gql`
 query userNotification($todayDate: Timestamptz!) {
  userPushNotifications(
    order_by: {notification: {createdAt: Desc}}
    where: {notification: {notifyTo: {_in: ["staff", "super_admin"]}}}
  ) {
    notification {
      message
      title
      createdAt
    }
    id
    readStatus
  }
  olderNotifications: userPushNotifications(
    where: {notification: {notifyTo: {_in: ["staff", "super_admin"]}, createdAt: {_lt: $todayDate}}}
    order_by: {notification: {createdAt: Desc}}
  ) {
    notification {
      message
      title
      createdAt
    }
    id
    readStatus
  }
  todaysNotifications: userPushNotifications(
    where: {notification: {notifyTo: {_in: ["staff", "super_admin"]}, createdAt: {_gte: $todayDate}}}
    order_by: {notification: {createdAt: Desc}}
  ) {
    notification {
      message
      title
      createdAt
    }
    id
    readStatus
  }
}
`;

const MARK_AS_READ_MUTATION = gql`
  mutation markAsRead($keyId: Uuid!, $set: Bool!) {
    v2UpdateUserPushNotificationsById(
      keyId: $keyId
      updateColumns: {readStatus: {set: $set}}
    ) {
      affectedRows
    }
  }
`;

export function useFetchUserNotifications() {
  const { data, loading, error, refetch } = useQuery(STAFF_NOTIFICATIONS_QUERY, {
    variables: { todayDate: new Date().toLocaleDateString('en-IN').split('/').reverse().join('-') },
    context: {
      headers: {
        'x-hasura-role': 'staff'
      }
    }
  });
  return { data, loading, error, refetch };
}

export function useMarkNotificationRead() {
  const { refetch } = useFetchUserNotifications();

  const [markAsRead] = useMutation(MARK_AS_READ_MUTATION,
    {
      context: {
        headers: {
          'x-hasura-role': 'staff'
        }
      },
      onCompleted: () => {
        refetch();
      }
    }
  );
  return { markAsRead };
}